import React from 'react';
import { motion, MotionProps } from 'framer-motion';

export const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
};

type MotionTag = 'div' | 'h1' | 'h2' | 'h3' | 'p';

const MOTION_COMPONENTS = {
    div: motion.div,
    h1: motion.h1,
    h2: motion.h2,
    h3: motion.h3,
    p: motion.p,
};

const Motion = ({ children, tag, className, ...framerProps }: {
    children: React.ReactNode,
    tag: MotionTag
} & MotionProps & { className?: string }) => {
    const [isMounted, setIsMounted] = React.useState(false);

    React.useEffect(() => {
        setIsMounted(true);
    }, []);

    // SSR and first client render use a plain element to avoid mismatches.
    if (!isMounted) {
        return React.createElement(tag, { className }, children);
    }

    return React.createElement(MOTION_COMPONENTS[tag], { ...framerProps, className }, children);
};

export default Motion;
